import { Extension } from "@tiptap/core";
import { saveAs } from "file-saver";
import { DocxSerializer, defaultMarks, defaultNodes } from "prosemirror-docx";
import { Packer } from "docx";
import { ActionButton } from "../../components";

const nodeSerializer = {
	...defaultNodes,
	hardBreak: defaultNodes.hard_break,
	codeBlock: defaultNodes.code_block,
	orderedList: defaultNodes.ordered_list,
	listItem: defaultNodes.list_item,
	bulletList: defaultNodes.bullet_list,
	horizontalRule: defaultNodes.horizontal_rule,
	// Requirement Buffer on browser
	image(state, node) {
		// No image
		state.renderInline(node);
		state.closeBlock(node);
	}
};
const docxSerializer = new DocxSerializer(nodeSerializer, defaultMarks);

export const ExportWord = Extension.create({
	name: "exportWord",
	addOptions() {
		return {
			...this.parent?.(),
			button: ({ editor, t }) => ({
				component: ActionButton,
				componentProps: {
					icon: "ExportWord",
					action: () => {
						editor?.commands.exportToWord();
					},
					tooltip: t("editor.exportWord.tooltip"),
					isActive: () => false,
					disabled: false
				}
			})
		};
	},
	addCommands() {
		return {
			exportToWord:
				() =>
				({ editor }) => {
					const opts = {
						getImageBuffer: async src => {
							const response = await fetch(src);
							const arrayBuffer = await response.arrayBuffer();
							return new Uint8Array(arrayBuffer);
						}
					};
					const wordDocument = docxSerializer.serialize(editor.state.doc, opts);
					Packer.toBlob(wordDocument).then(blob =>
						saveAs(new Blob([blob]), "document.docx")
					);
					return true;
				}
		};
	}
});
